import React, { Component } from 'react';
import {
  CapaContainer,
  CapaWrapper,
  HeaderBtn,
  ColorWrapper,
  DetailsBody,
  ElementsCapa,
  ElementsCapaList,
  ListElement,
  HeaderInfo,
  HeaderTitle,
  HeaderTitleWrapper,
  HeaderDescription,
  RepWrapper
} from './CapaLlegendaElement';
import { CapaLlegendaFooter } from './CapaLlegendaFooter/CapaLlegendaFooter';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getLegendURL } from '../../Utils/MapUtils';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import {
  CustomizedAccordionSummary,
  hideStyleByRange,
  getCustomizedAccordionStyle,
  getCustomizedAccordionSummaryStyle,
  getLayerHeaderTitle,
  checkIfLayerHasRules,
  scaleSvgFill
} from './CapaLlegendaUtils';
import { renderErrorIcon, renderDefaultIcon, renderChildIcon } from './CapaLlegendaIcons/CapaLlegendaIcons';
import { CapaLlegendaVisibilityIcon } from './CapaLlegendaIcons/CapaLlegendaVisibilityIcon';
import { displayComponents } from '../../Utils/VisorsUtils';

export class CapaLlegenda extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleSelected: 0, //estilo seleccionado (por defecto el primero que es el 0)
      isHolded: false
    };

    this.timerRef = React.createRef();
    this.isLongPress = React.createRef();
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.expandAll !== this.props.expandAll) {
      this.props.layer.setExpanded(nextProps.expandAll);
    }
  };

  componentDidUpdate() {
    hideStyleByRange(this.props.scale, this.props.layer.getName(), this.props.layer);
  }

  componentDidMount = () => {
    this.props.layer.getStyles().forEach((style, idx) => {
      this.props.layer.generateUIStyle(idx, this.props.layer, this.useForceUpdate);
    });
  };

  /**
   *
   * @param {*} panel
   * @desc Función encargada de actualizar el estilo seleccionado de la capa
   */
  handleStyleChange = (newStyleSelected) => {
    this.setState({ styleSelected: newStyleSelected });
  };

  /**
   *
   * @param {*} panel
   * @desc Función encargada de cambiar el estado al expandir o contraer el accordion
   */
  handleAccordionChange = (panel) => () => {
    if (!this.state.isHolded) {
      this.props.layer.setExpanded(!this.props.layer.isExpanded() ? panel : false);
      this.forceUpdate();
    }
  };

  /**
   * @desc Función invocada al eliminar una capa de la leyenda
   */
  handleDeleteLayer = (layer) => {
    this.props.handleDeleteLayer(layer); //re-renderizar la leyenda
    this.props.layer.setVisible(true);
    this.props.layer.setChecked(false);
    this.props.layer.setExpanded(false); //evita que se quede abierta la siguiente layer
    this.forceUpdate();
  };

  /**
   *
   * @param {*} event
   * @desc Función para cambiar el estado de visibilidad de la capa (boton ojo)
   */
  onVisibilityBtnClick = (event) => {
    event.stopPropagation();
    this.forceUpdate(); //TODO remediar esto

    this.props.layer.setVisible(!this.props.layer.isVisible());
    this.props.layer.isVisible() ? this.props.layer.getOLLayer().setVisible(true) : this.props.layer.getOLLayer().setVisible(false);
    this.props.handleEraseInfoCard(this.props.layer);
  };

  // Funciones que controlan el estado dragging de las capas de la leyenda al pasar un tiempo manteniendo una capa pulsada

  // Movil
  onTouchStart = () => {
    this.longPressTimer();
  };

  //Desktop
  onMouseStart = () => {
    this.longClickTimer();
  };

  onTouchEnd = () => {
    clearTimeout(this.timerRef.current);
    this.props.layer.setDragging(false);
    this.isLongPress.current = false;
    this.forceUpdate();
  };

  longPressTimer = () => {
    this.timerRef.current = setTimeout(() => {
      this.isLongPress.current = true;
      this.props.layer.setDragging(true);
      this.forceUpdate();
    }, 500);
  };

  onMouseEnd = () => {
    clearTimeout(this.timerRef.current);
    this.props.layer.setDragging(false);
    this.setState({ isHolded: false });
    this.forceUpdate();
  };

  longClickTimer = () => {
    this.timerRef.current = setTimeout(() => {
      this.setState({ isHolded: true });
      this.props.layer.setDragging(true);
      this.forceUpdate();
    }, 300);
  };

  useForceUpdate = () => {
    this.setState({});
  };

  /**
   * @desc funcion para generar el estilo de la capa
   */
  createStyle = () => {
    this.props.layer.generateUIStyle(this.props.layer.getStyleSelected(), this.props.layer, this.useForceUpdate);
  };

  update = () => {
    this.setState({});
  };

  render() {
    return (
      <>
        {!this.props.layer.hasRule(this.props.layer.getStyleSelected()) && this.createStyle()}
        <CapaContainer>
          <CapaWrapper>
            <Accordion
              expanded={this.props.layer.isExpanded() === 'panel2'}
              onChange={this.handleAccordionChange('panel2')}
              sx={() => getCustomizedAccordionStyle(this.props.layer.isDragging())}>
              <CustomizedAccordionSummary
                onTouchStart={() => this.onTouchStart()}
                onTouchEnd={() => this.onTouchEnd()}
                onMouseDown={() => this.onMouseStart()}
                onMouseUp={() => this.onMouseEnd()}
                expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
                aria-controls="panel2bh-content"
                id="panel2bh-header"
                sx={() => getCustomizedAccordionSummaryStyle(this.props.layer.isDragging())}>
                <Typography
                  component={'span'}
                  sx={{
                    width: 'fit-content',
                    display: 'inline-flex',
                    justifyContent: 'start',
                    paddingTop: this.props.layer.isExpanded() && this.props.layer.getTitle().length > 35 ? '7px' : 'none',
                    alignItems: this.props.layer.isExpanded() && this.props.layer.getTitle().length > 35 ? 'none' : 'center',
                    fontSize: window.innerWidth < 768 ? '12px' : '13px',
                    fontWeight: '100',
                    fontFamily: 'Open Sans',
                    margin: !displayComponents.hideCapa ? '10px' : 0
                  }}>
                  {displayComponents.hideCapa && (
                    <HeaderBtn
                      expanded={this.props.layer.isExpanded()}
                      length={this.props.layer.getTitle().length}
                      title={getTranslatedKey('showLayer')}
                      onClick={(event) => this.onVisibilityBtnClick(event)}
                      onMouseEnter={() => this.setState({ isVisibilityHovered: true })}
                      onMouseLeave={() => this.setState({ isVisibilityHovered: false })}
                      className="visibility-btn">
                      {this.props.layer.hasError() ? (
                        renderErrorIcon(this.props.fontSizeEnabled)
                      ) : this.props.layer.isVisible() ? (
                        this.props.layer.hasScale() ? (
                          scaleSvgFill(this.props.layer, this.props.scale, this.props.fontSizeEnabled)
                        ) : (
                          <CapaLlegendaVisibilityIcon fontSizeEnabled={this.props.fontSizeEnabled} type="visible" />
                        )
                      ) : this.props.layer.hasScale() ? (
                        <CapaLlegendaVisibilityIcon fontSizeEnabled={this.props.fontSizeEnabled} type="scale-not-visible" />
                      ) : (
                        <CapaLlegendaVisibilityIcon fontSizeEnabled={this.props.fontSizeEnabled} type="not-visible" />
                      )}
                    </HeaderBtn>
                  )}
                  {this.props.layer.isTemporal() ? (
                    this.props.layer.setTemporalStyle(this.props.layer.getFileName())
                  ) : !this.props.layer.hasChilds() && this.props.layer.isExternal() && getLegendURL(this.props.layer) !== false ? (
                    <ColorWrapper length={this.props.layer.getTitle().length} expanded={this.props.layer.isExpanded()}>
                      {renderDefaultIcon(this.props.fontSizeEnabled)}
                    </ColorWrapper>
                  ) : this.props.layer.hasChildsOrRules() ? (
                    <ColorWrapper length={this.props.layer.getTitle().length} expanded={this.props.layer.isExpanded()}>
                      {renderChildIcon(this.props.fontSizeEnabled)}
                    </ColorWrapper>
                  ) : !this.props.layer.hasChilds() &&
                    (!this.props.layer.getRule(this.props.layer.getStyleSelected()) ||
                      this.props.layer.getRule(this.props.layer.getStyleSelected()) === 'error') ? (
                    <ColorWrapper length={this.props.layer.getTitle().length} expanded={this.props.layer.isExpanded()}>
                      {renderDefaultIcon(this.props.fontSizeEnabled)}
                    </ColorWrapper>
                  ) : (
                    <RepWrapper length={this.props.layer.getTitle().length} id="Representación" expanded={this.props.layer.isExpanded()}>
                      {this.props.layer.getRule(this.props.layer.getStyleSelected())}
                    </RepWrapper>
                  )}

                  <HeaderInfo>
                    <HeaderTitleWrapper title={this.props.layer.getTitle()} fontSizeEnabled={this.props.fontSizeEnabled}>
                      <HeaderTitle
                        length={this.props.layer.getTitle().length}
                        expanded={this.props.layer.isExpanded()}
                        fontSizeEnabled={this.props.fontSizeEnabled}>
                        {this.props.layer.getTitle()}
                      </HeaderTitle>
                    </HeaderTitleWrapper>
                  </HeaderInfo>
                </Typography>
              </CustomizedAccordionSummary>
              <AccordionDetails id="notSortable2" sx={{ paddingBottom: '8px', paddingTop: '0px' }}>
                <DetailsBody>
                  <HeaderDescription fontSizeEnabled={this.props.fontSizeEnabled} title={getLayerHeaderTitle(this.props.layer)}>
                    {getLayerHeaderTitle(this.props.layer)}
                  </HeaderDescription>
                  <ElementsCapa>
                    <ElementsCapaList>
                      {checkIfLayerHasRules(this.props.layer) && (
                        <ListElement fontSizeEnabled={this.props.fontSizeEnabled} id={'layerInfo_' + this.props.layer.getName()}>
                          {this.props.layer.getRule(this.props.layer.getStyleSelected())}
                        </ListElement>
                      )}
                    </ElementsCapaList>
                  </ElementsCapa>
                </DetailsBody>
                <CapaLlegendaFooter
                  taulaApiConditions={this.props.taulaApiConditions}
                  taulaFc={this.props.taulaFc}
                  taulaGeom={this.props.taulaGeom}
                  taulaTotal={this.props.taulaTotal}
                  taulaPage={this.props.taulaPage}
                  setTaulaGeom={this.props.setTaulaGeom}
                  toggleAlert={this.props.toggleAlert}
                  user={this.props.user}
                  getExternTable={this.props.getExternTable}
                  update={this.update}
                  editVector={this.props.editVector}
                  setEditing={this.props.setEditing}
                  statsLayer={this.props.statsLayer}
                  showAlert={this.props.showAlert}
                  statsLayerSelect={this.props.statsLayerSelect}
                  scrollToFiltre={this.props.scrollToFiltre}
                  closeTable={this.props.closeTable}
                  setTaulaSpacialBbox={this.props.setTaulaSpacialBbox}
                  taulaSpacialBbox={this.props.taulaSpacialBbox}
                  taulaFullFilter={this.props.taulaFullFilter}
                  setTaulaSpacialFilter={this.props.setTaulaSpacialFilter}
                  taulaSpacialFilter={this.props.taulaSpacialFilter}
                  setTaulaLayer={this.props.setTaulaLayer}
                  deleteTaula={this.props.deleteTaula}
                  changeLlegendaOpen={(isOpen) => this.props.changeLlegendaOpen(isOpen)}
                  taulaResp={this.props.taulaResp}
                  setTaulaResp={this.props.setTaulaResp}
                  setTaulaConditions={this.props.setTaulaConditions}
                  taulaConditions={this.props.taulaConditions}
                  taulaArray={this.props.taulaArray}
                  taulaLayer={this.props.taulaLayer}
                  taulaOpen={this.props.taulaOpen}
                  selectVector={this.props.selectVector}
                  taulaFilters={this.props.taulaFilters}
                  isSelecting={this.props.isSelecting}
                  resetSelected={this.props.resetSelected}
                  selectedArray={this.props.selectedArray}
                  selectedFeatures={this.props.selectedFeatures}
                  toggleSelecting={this.props.toggleSelecting}
                  setTaulaFilters={this.props.setTaulaFilters}
                  filterVector={this.props.filterVector}
                  filterSource={this.props.filterSource}
                  getTaulaArray={this.props.getTaulaArray}
                  onStyleChangeOrder={this.props.onStyleChangeOrder}
                  handleEraseInfoCard={this.props.handleEraseInfoCard}
                  map={this.props.map}
                  layer={this.props.layer}
                  arrayLayers={this.props.arrayLayers}
                  arrayExternalLayers={this.props.arrayExternalLayers}
                  llegendaObj={this.props.llegendaObj}
                  handleDeleteLayer={(layer) => this.handleDeleteLayer(layer)}
                  handleStyleChanged={this.handleStyleChange}
                  handleArrayChange={this.props.handleArrayChange}
                  fontSizeEnabled={this.props.fontSizeEnabled}
                  toggleDrawing={this.props.toggleDrawing}></CapaLlegendaFooter>
              </AccordionDetails>
            </Accordion>
          </CapaWrapper>
        </CapaContainer>
      </>
    );
  }
}
